import { message } from 'antd'
import { getAnouncements, searchAnouncements, getDetail } from '../../api/api'

export default {
  namespace: 'secureModule',
  state: {
    announcementList: [],
    totalData: [],
    totalSize: '',
    detail: {},
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
  effects: {
    * getAnouncements({ payload }, { call, put }) {
      const { page = 1, size = 10, lang } = payload
      try {
        const res = yield call(getAnouncements, page, size, lang)
        const { data = [], cnt, code, msg } = res
        if (code === 200) {
          const announcementList = data.length > 0 ? data.map((item, index) => {
            return {
              key: index,
              id: item.id,
              mid: item.mid,
              title: item.title,
              level: item.level,
              description: item.details,
              date: item.created_at,
            }
          }) : []
          yield put({ type: 'save', payload: { announcementList, totalSize: cnt, totalData: data } })
        } else {
          message.error(msg)
        }
      } catch (e) {
        message.error(e.message)
      }
    },
    * searchAnouncements({ payload }, { call, put }) {
      const { search, lang } = payload
      try {
        const res = yield call(searchAnouncements, search, lang)
        const { data = [], cnt, code, msg } = res
        if (code === 200) {
          const announcementList = data.length > 0 ? data.map((item, index) => {
            return {
              key: index,
              id: item.id,
              mid: item.mid,
              title: item.title,
              level: item.level,
              description: item.details,
              date: item.created_at,
            }
          }) : []
          yield put({ type: 'save', payload: { announcementList, totalSize: cnt } })
        } else {
          message.error(msg)
        }
      } catch (e) {
        message.error(e.message)
      }
    },
    * getDetail({ payload }, { call, put }) {
      const { id, lang } = payload
      try {
        const res = yield call(getDetail, id, lang)
        const { data = {}, code, msg } = res
        if (code === 200) {
          yield put({ type: 'save', payload: { detail: data } })
        } else {
          message.error(msg)
        }
      } catch (e) {
        message.error(e.message)
      }
    },
  },
}
